import { Col, Row } from 'antd';
import { t } from 'i18next';
import { observer } from 'mobx-react-lite';
import { Card } from 'src/components/Card/Card';
import { DataView } from 'src/components/DataView/DataView';
import { MerchantSnapshotDto } from 'src/generated-api-client';

type LoanApplicationMerchantSnapshotGeneralInfoProps = {
    snapshot: MerchantSnapshotDto;
};

export const LoanApplicationMerchantSnapshotGeneralInfo = observer(
    ({ snapshot }: LoanApplicationMerchantSnapshotGeneralInfoProps) => {
        return (
            <Card
                title={t('LoanApplication.MerchantSnapshot.GeneralInfo.Title')}
            >
                <Row gutter={[16, 16]}>
                    <Col xs={24} sm={12} md={12}>
                        <DataView
                            label={t(
                                'LoanApplication.MerchantSnapshot.GeneralInfo.MerchantName',
                            )}
                            value={snapshot.merchant?.name}
                        />
                    </Col>
                    <Col xs={24} sm={12} md={12}>
                        <DataView
                            label={t(
                                'LoanApplication.MerchantSnapshot.GeneralInfo.SnapshotDate',
                            )}
                            value={snapshot.merchant?.createdAt}
                            formatValue="date"
                        />
                    </Col>
                </Row>
            </Card>
        );
    },
);
